module.exports = __webpack_public_path__ + "img/blading-for-bees-logo.60abbb80.png";